import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
// import TextField from "@mui/material/TextField";
import { branch, renderComponent, compose } from "recompose";
import { fullName, fullAddress } from "../../functions/users";
// import { fullEmail } from "../../functions/users";
import { injectIntl } from "react-intl";
// import { Input } from "@mui/material";

const NoUser = (props) => (
  <React.Fragment>
    <Typography variant="body1" gutterBottom>
      Profile
    </Typography>
    <div>No user available</div>
  </React.Fragment>
);

const hasCurrentUser = ({ currentUser }) => Boolean(currentUser == null);

const noUserAvailable = branch(hasCurrentUser, renderComponent(NoUser));

const SimpleProfile = React.memo(function SimpleProfile(props) {
  const formatMessage = props.intl.formatMessage;
  const currentUser = props.currentUser;
  const { address } = currentUser;
  const userFullName = fullName(currentUser, " ");
  const addressLine = fullAddress(address);

  return (
    <React.Fragment>
      <Grid container spacing={24} style={{ textAlign: "center" }}>
        <Grid item xs={12} sm={12}>
          <Typography variant="h5">
            {formatMessage({ id: "profile.header.headline" })}
          </Typography>
          <Typography variant="h5">{userFullName}</Typography>
          <Typography variant="subtitle1" style={{ marginBottom: "20px" }}>
            {addressLine}
          </Typography>
          <Typography component="p">
            {formatMessage({ id: "profile.header.paragraph" })}
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
});

export default compose(noUserAvailable, injectIntl)(SimpleProfile);
